import React from 'react';
import PropTypes from 'prop-types';

const Checkbox = ({ label, name, checked, onChange }) => {
  return (
    <div className='checkbox'>
      <input
        type="checkbox"
        id={name}
        name={name}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className='checkboxInput'
      />
      <label htmlFor={name} className='checkboxLabel'>
        {label}
      </label>
    </div>
  );
};

Checkbox.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

Checkbox.defaultProps = {
  checked: false,
};

export default Checkbox;
